import { type Theme } from "@mui/material/styles";
import { hexToRGBA } from "src/utils/hex-to-rgba";

const Tooltip = (theme: Theme) => {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: hexToRGBA(theme.palette.grey[900], 0.9),
        },
        arrow: {
          color: hexToRGBA(theme.palette.grey[900], 0.9),
        },
      },
    },
  };
};

export { Tooltip };
